export default __webpack_public_path__ + "static/media/Dot.ba9818b5.webp";